import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUser } from 'src/app/domain/registration/models/IUser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.sass'],
})
export class ResetPasswordDialogComponent implements OnInit {
  form: FormGroup;
  private generatePasswordSub?: Subscription;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: IUser }
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnDestroy(): void {
    this.generatePasswordSub?.unsubscribe();
  }

  private buildForm(): void {
    this.form = this.fb.group(
      {
        generatePassword: [false],
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required]],
        requireChangePassword: [true],
      },
      { validators: ResetPasswordDialogComponent.passwordMatchValidator }
    );

    this.generatePasswordSub = this.form
      .get('generatePassword')
      ?.valueChanges.subscribe((generatePassword) => {
        this.syncPasswordValidators(generatePassword === true);
      });
    this.syncPasswordValidators(false);
  }

  private syncPasswordValidators(generatePassword: boolean): void {
    const newPassword = this.form.get('newPassword');
    const confirmPassword = this.form.get('confirmPassword');

    if (generatePassword) {
      newPassword?.clearValidators();
      confirmPassword?.clearValidators();
      newPassword?.setValue('', { emitEvent: false });
      confirmPassword?.setValue('', { emitEvent: false });
    } else {
      newPassword?.setValidators([Validators.required, Validators.minLength(6)]);
      confirmPassword?.setValidators([Validators.required]);
    }

    newPassword?.updateValueAndValidity({ emitEvent: false });
    confirmPassword?.updateValueAndValidity({ emitEvent: false });
    this.form.updateValueAndValidity({ emitEvent: false });
  }

  static passwordMatchValidator(
    group: AbstractControl
  ): ValidationErrors | null {
    const newPassword = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    const generatePassword = group.get('generatePassword')?.value === true;
    if (generatePassword) return null;
    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  get passwordMismatch(): boolean {
    return (
      this.form.hasError('passwordMismatch') &&
      !!this.form.get('confirmPassword')?.value
    );
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onConfirm(): void {
    if (this.form.invalid) {
      return;
    }

    const { generatePassword, newPassword, confirmPassword, requireChangePassword } =
      this.form.value;

    this.dialogRef.close(generatePassword ? {
      generatePassword,
      requireChangePassword,
    } : {
      newPassword,
      confirmPassword,
      requireChangePassword,
    });
  }
}
